import {readTimelineAnimationWindow,type TimelineAnimationWindow} from './animation-window';
const record=(v:unknown):v is Record<string,unknown>=>!!v&&typeof v==='object'&&!Array.isArray(v);
export type FadeWindow=TimelineAnimationWindow;
export function hasFadeWindows(document:unknown):boolean{
  return record(document)&&record(document.items)&&Object.values(document.items).some(item=>record(item)&&(item.visualFadeWindow!==undefined||item.audioFadeWindow!==undefined));
}
export function hasValidFadeWindows(item:unknown,fps:number):boolean{
  if(!record(item))return false;
  return (['visual','audio'] as const).every(kind=>{
    const raw=item[`${kind}FadeWindow`];if(raw===undefined)return true;
    const window=readTimelineAnimationWindow(raw);
    const keys=kind==='visual'?['fadeInDurationInSeconds','fadeOutDurationInSeconds']:['audioFadeInDurationInSeconds','audioFadeOutDurationInSeconds'];
    if(!window||!keys.every(key=>typeof item[key]==='number'&&Number.isFinite(item[key])&&Number(item[key])>=0))return false;
    const start=window.startInSeconds*fps,end=window.endInSeconds*fps;
    return Number.isFinite(start)&&Number.isFinite(end)&&Number.isFinite(end-start)&&end>start;
  });
}
